

import { useSelector } from "react-redux";
import styled from "styled-components"
import truckDark from "../../images/svg/topYogunluk/truck-dark.svg"
import truckLight from "../../images/svg/topYogunluk/truck-light.svg"

import yukDark from "../../images/svg/topYogunluk/list-dark.svg"
import yukLight from "../../images/svg/topYogunluk/list-light.svg"
import getPastDateAndTime from "../../helper/date/getPastDateAndTime";
import PageTopTitle from "../../components/shared/PageTopTitle";
import useWindowDimensions from "../../hooks/useWindowSize";
const Container = styled.div`
  width: 100%;
  height: 100%;
  color: ${({theme}) => theme.mainTextColor};
  .wrapper{
    width: 100%;
    .content{
        padding: 30px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 20px;
        color: ${({theme}) => theme.mainTextColor};
    }

    .yogunluk-desc-container{

        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .yogunluk-desc-item{
            display: flex;
            align-items: center;
            gap: 10px;

            .item-icon{
                width: 30px;
            }

            .item-text{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-xl);
            }
        }
    }
  }
  
`

const GarageItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid ${({theme}) => theme.mainTextColor};
    border-radius: 10px;
    width: calc(25% - 20px);

    .garage-name{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-xl);
        border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
        width: 100%;
        padding: 5px 10px;
        display: flex;
        justify-content: center;
    }

    .yogunluk-container{
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 15px 0;

        .yogunluk-container-item{
            display: flex;
            align-items: center;
            gap: 10px;


            .item-text{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-xl);
            }

            .item-icon{
                width: 25px;

            }
        }
    }

    .date-container{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        width: 100%;
        text-align: center;
        border-top: 1px solid ${({theme}) => theme.mainTextColor};
        padding: 5px 10px;

    }


  @media (max-width: 1150px) {
    width: calc(50% - 20px);

  }

  @media (max-width: 550px) {
    width: 100%;
  }
    
`

const KamyonGarajYogunluk = () => {

  const { garajYogunlukList } = useSelector((state) => state.admin);
  const {theme} = useSelector(state => state.layout)
  const {windowDimensions} = useWindowDimensions()

  return (
    <Container>
        <div className="wrapper">
            {
                windowDimensions.width > 850 &&
                <PageTopTitle title={"Kamyon Garajları Yoğunlukları"} position="sticky"/>
            }
            <div className="content">
                {
                    windowDimensions.width <= 850 &&
                    <div className="yogunluk-desc-container">
                        <div className="yogunluk-desc-item">
                            <img src={theme === "dark" ? yukLight : yukDark} className="item-icon" alt="" />
                            <span className="item-text">Yük Yoğunluğu</span>
                        </div>
                        <div className="yogunluk-desc-item">
                            <img src={theme === "dark" ? truckLight : truckDark} className="item-icon" alt="" />
                            <span className="item-text">Araç Yoğunluğu</span>
                        </div>
                    </div>
                }
                {
                    garajYogunlukList.map((item) =>(
                        <GarageItem>
                            <div className="garage-name">{item.branchName}</div>
                            <div className="yogunluk-container">
                                <div className="yogunluk-container-item">
                                    <div className="item-text">Yük : <span style={{color: item.loadDensity <= 33 ? "#0EAC00" : item.loadDensity <= 66 ? "#EBB00E" :"#FF0000" }}>%{item.loadDensity}</span> </div>
                                    <img className="item-icon" src={theme === "dark" ? yukLight : yukDark} alt="" />
                                </div>
                                <div className="yogunluk-container-item">
                                    <div className="item-text">Araç: <span style={{color: item.vehicleDensity <= 33 ? "#0EAC00" : item.vehicleDensity <= 66 ? "#EBB00E" :"#FF0000" }}>%{item.vehicleDensity}</span></div>
                                    <img className="item-icon" src={theme === "dark" ? truckLight : truckDark} alt="" />
                                </div>
                            </div>
                            <div className="date-container"><span style={{fontSize: "12px"}}>Son Güncelleme:</span> {new Date(item.entryTime).toLocaleDateString()}</div>
                        </GarageItem>
                    ))
                }
            </div>
        </div>
    </Container>
  )
}

export default KamyonGarajYogunluk